// Transfer
export const TRANSFER = '/logistic/transport';
export const GET_TRANSFERS = '/logistic/transport/';
export const DELETE_TRANSFER = '/logistic/transport';
export const ADD_TRANSFER = '/logistic/transport/';
export const UPDATE_TRANSFER = '/logistic/transport';

// Transfer Category
export const TRANSFER_CATEGORY = '/logistic/category';
export const GET_TRANSFER_CATEGORIES = '/logistic/category/';
export const DELETE_TRANSFER_CATEGORY = '/logistic/category';
export const ADD_TRANSFER_CATEGORY = '/logistic/category/';
export const UPDATE_TRANSFER_CATEGORY = '/logistic/category';

// Transfer Company
export const TRANSFER_COMPANY = '/logistic/company';
export const GET_TRANSFER_COMPANIES = '/logistic/company/';
export const EXISTS_TRANSFER_COMPANY = '/logistic/company/exists';
export const DELETE_TRANSFER_COMPANY = '/logistic/company';
export const ADD_TRANSFER_COMPANY = '/logistic/company/';
export const UPDATE_TRANSFER_COMPANY = '/logistic/company';

// Transfer Type
export const TRANSFER_TYPE = '/logistic/type';
export const GET_TRANSFER_TYPE = '/logistic/type/';
export const GET_TRANSFER_TYPE_COMPANY = '/logistic/type/company';
export const EXISTS_TRANSFER_TYPE = '/logistic/type/exists';
export const DELETE_TRANSFER_TYPE = '/logistic/type';
export const ADD_TRANSFER_TYPE = '/logistic/type/';
export const UPDATE_TRANSFER_TYPE = '/logistic/type';

// Transfer Driver
export const TRANSFER_DRIVER = '/logistic/driver';
export const GET_TRANSFER_DRIVERS = '/logistic/driver/';
export const GET_TRANSFER_DRIVERS_QUERY = '/logistic/driver/query';
export const DELETE_TRANSFER_DRIVER = '/logistic/driver';
export const ADD_TRANSFER_DRIVER = '/logistic/driver/';
export const UPDATE_TRANSFER_DRIVER = '/logistic/driver';
